<template>
  <div>
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <div class="home-container">
        <div v-for="(item, key) in sortList" :key="key">
          <!-- 轮播 -->
          <swiper v-if="item.keyword === 'banners_mobile' && item.content === 1" :swipeList="swipeList" />
          <!-- 应用 -->
          <home-app
            v-if="item.keyword === 'home_app' && item.content === 1"
            :reportShow="reportShow"
            :ruleShow="ruleShow"
            @show-rule="ruleShow = true"
            @close-rule="ruleShow = false"
          ></home-app>
          <!-- 活动 -->
          <active v-if="item.keyword === 'event_mobile' && item.content === 1" :activeList="activeList" />
          <!-- 直播 -->
          <live v-if="item.keyword === 'lives_mobile' && item.content === 1" :onlines="onlines" />
          <!-- 专辑 -->
          <alumn v-if="item.keyword === 'album_mobile' && item.content === 1" />
          <!-- 新闻 -->
          <newList v-if="item.keyword === 'news_mobile' && item.content === 1" :news="news" />
          <!-- 通知 -->
          <noticeList v-if="item.keyword === 'notes_mobile' && item.content === 1" :notes="notes" />
        </div>
      </div>
    </van-pull-refresh>
    <infoAffirm :show="infoShow" @on-close="infoShow = false" />
    <infoAffirm2 :show="infoShow2" @on-close="oncloseInfoAffirm2" />
    <infoAffirm3 :show="infoShow3" @on-close="infoShow3 = false"></infoAffirm3>
  </div>
</template>

<script>
import dingtalk from 'dingtalk-jsapi'
import {getHomeInfo, getHomePortalshow, getUser} from '@/api'
import {
  menuPermission,
  ddJugeTokenTimeOut,
  selectDingdingThird,
  bindDingDingThird,
  DingDingGetUserToken
} from '@/api/dd'
import {getRemainderTime} from '@/ultis'
import swiper from './swiper.vue'
import active from './active.vue'
import live from './live.vue'
import newList from './newList.vue'
import noticeList from './noticeList.vue'
import alumn from './alumn/index.vue'
import homeApp from '../customization/home-app.vue'
import infoAffirm from '../customization/info-affirm.vue'
import infoAffirm2 from '../customization/info-affirm2.vue'
import infoAffirm3 from '../customization/info-affirm3.vue'
export default {
  data() {
    return {
      infoShow: false,
      infoShow2: false,
      infoShow3: false,
      refreshLoading: false,
      activeList: [
        {
          value: 0,
          label: '今日',
          color: 'rgba(236,110,100,1)',
          bg: 'rgba(236,110,100,0.16)'
        },
        {
          value: 0,
          label: '主讲',
          color: 'rgba(244,164,84,1)',
          bg: 'rgba(244,164,84,0.16)'
        },
        {
          value: 0,
          label: '参与',
          color: 'rgba(39,169,164,1)',
          bg: 'rgba(39,169,164,0.16)'
        },
        {
          value: 0,
          label: '公开',
          color: 'rgba(68,101,243,1)',
          bg: 'rgba(68,101,243,0.16)'
        }
      ],
      swipeList: [],
      notes: [],
      news: [],
      onlines: [],
      sortList: [],
      reportShow: false,
      ruleShow: false,

      length: 1
    }
  },
  components: {
    live,
    swiper,
    active,
    newList,
    noticeList,
    alumn,
    homeApp,
    infoAffirm,
    infoAffirm2,
    infoAffirm3
  },
  watch: {
    ruleShow(newV) {
      if (newV) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    }
  },
  created() {
    if (this.isDingTalk()) {
      this.infoShow3 = true
    }
    const currentData = new Date().getTime()
    const endDate = new Date('2024-09-27 00:00').getTime()

    if (this.length === 1) {
      if (currentData > endDate) {
        // this.infoShow = true
      } else {
        this.infoShow = false
        // this.infoShow2 = true
      }
    }

    this.length += 1
    console.log('created')
    console.log('this.appVersion', this.appVersion)
    if (this.appVersion === 'dd') {
      this.onDdLogin(this.createdInit)
    } else {
      this.createdInit()
    }
  },
  methods: {
    isDingTalk() {
      var userAgent = navigator.userAgent
      return /DingTalk/i.test(userAgent)
    },
    oncloseInfoAffirm2() {
      this.infoShow2 = false
      setTimeout(() => {
        this.infoShow = true
      }, 500)
    },
    async createdInit() {
      const {data} = await getUser()
      if (data) {
        this.$store.commit('setUser', data)
      } else {
        localStorage.clear()
        this.$router.replace('/login')
      }
      this.init()
      this.getSortShow()
      this.getMenu()
    },
    onDdTokenTimeOut(callback) {
      ddJugeTokenTimeOut()
        .then(res => {
          console.log('ddJugeTokenTimeOut', res)
          if (res.code === 0) {
            window.console.log('表示没有过期')
            callback()
          } else {
            window.console.log('表示已经过期')
            localStorage.removeItem('Authorization')
            this.onDdReady()
          }
        })
        .catch(err => {
          console.log('ddTokenTimeOut-catch', err)
          localStorage.removeItem('Authorization')
          this.onDdReady(callback)
        })
    },
    onDdLogin(callback) {
      const Authorization = localStorage.getItem('Authorization')
      if (Authorization) {
        window.console.log('ddLogin, token存在, 验证token是否过期')
        this.onDdTokenTimeOut(callback)
      } else {
        this.onDdReady(callback)
      }
    },
    onDdReady(callback) {
      dingtalk.ready(() => {
        window.console.log('进来dingtalk方法')
        localStorage.removeItem('Authorization')
        dingtalk.runtime.permission.requestAuthCode({
          corpId: 'dingcc49658297bd767bf5bf40eda33b7ba0',
          onSuccess: info => {
            window.console.log('进来dingtalk的onSuccess')
            const code = info.code
            selectDingdingThird(1, code).then(res => {
              window.console.log('selectDingdingThird', res)
              const data = res.data
              if (data && data.length > 0) {
                const accountId = data[0].coreAccountId
                DingDingGetUserToken(accountId).then(res => {
                  if (res.code === 0) {
                    localStorage.removeItem('Authorization')
                    const token = 'Bearer ' + res.data
                    localStorage.setItem('Authorization', token)
                    callback()
                  }
                })
              } else {
                dingtalk.runtime.permission.requestAuthCode({
                  corpId: 'dingcc49658297bd767bf5bf40eda33b7ba0',
                  onSuccess: info => {
                    const authCode = info.code
                    bindDingDingThird(1, authCode).then(res => {
                      if (res.code === 0) {
                        const data = res.data
                        const accountId = data[0].coreAccountId
                        DingDingGetUserToken(accountId).then(res => {
                          if (res.code === 0) {
                            localStorage.removeItem('Authorization')
                            const token = 'Bearer ' + res.data
                            localStorage.setItem('Authorization', token)
                            callback()
                          }
                        })
                      } else {
                        window.console.error('绑定失败')
                      }
                    })
                  }
                })
              }
            })
          },
          onFail: err => {
            window.console.error('onFail', err)
          }
        })
      })
    },

    getSortShow() {
      getHomePortalshow().then(res => {
        this.sortList = res.data
        const obj = {
          additional: '3',
          content: 1,
          eventPortalSettingId: '1557199570834817024',
          keyword: 'home_app',
          name: '应用',
          portalType: 2,
          sort: 1
        }
        this.sortList.splice(1, 0, obj)
        this.sortList = this.sortList.map((item, index) => {
          item.sort = index
          return item
        })
        console.log('this.sortList', this.sortList)
      })
    },
    getMenu() {
      menuPermission().then(res => {
        const menuIds = res.data.menuIds
        this.reportShow = menuIds.includes(6)
      })
    },
    async onRefresh() {
      await this.init()
      setTimeout(() => {
        this.refreshLoading = false
      }, 500)
    },
    init() {
      getHomeInfo().then(res => {
        const nowTime = +new Date()
        const {today_count, main_count, join_count, public_count, banners, notes, news, onlines} = res.data
        this.activeList[0].value = today_count
        this.activeList[1].value = main_count
        this.activeList[2].value = join_count
        this.activeList[3].value = public_count
        if (banners && banners.length > 0) {
          this.swipeList = banners.sort((a, b) => {
            return a.eventBannerOrder - b.eventBannerOrder
          })
        }
        this.notes = notes || []
        this.news = news
        this.onlines = onlines || []
        this.onlines.forEach(item => {
          if (nowTime < item.event_start_time) {
            item.time = getRemainderTime(parseInt(item.event_start_time / 1000))
          }
        })
        console.log('this.swipeList', this.swipeList)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.home-container {
  padding: 0 16px 10px;
}
</style>
